define('lq/events/actions/platformCommand',[
    'lq/events/actions/eventAction',
    'jquery',
    'underscore',
    'lq'
], function (EventAction, $, _, lq) {
    'use strict';

    function PlatformCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.mapping = eventData.mapping;
        return this;
    }

    EventAction.extend(PlatformCommand, EventAction);

    PlatformCommand.typeName = 'PlatformCommand';

    PlatformCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    PlatformCommand.prototype.createEventActionRequest = function () {
        var self = this;

        var commandViewModelKeysValues = {};

        _.each(self.piping.dropFactory.getAllDrops(), function (drop) {
            if (drop.getValue) {
                var value = drop.getValue();
                commandViewModelKeysValues[drop.data.viewModelKey] = value;
            }
        });

        return {
            eventActionType: "PlatformCommand",
            command: self.eventData.command,
            commandViewModelKeys: commandViewModelKeysValues
        };
    };

    PlatformCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.Outputs) {
            var self = this;
            _.each(this.mapping.fields, function (mapping) {
                self.piping.parameters.locals.setValue(mapping.targetParameter, eventActionResponse.Outputs[mapping.sourceOutput]);
            });
        }

        if (eventActionResponse.TenantToReload) {
            var data = {
                tenantName: eventActionResponse.TenantToReload
            };

            var reloadDesigner = this.piping.dispatcher.doDispatch(lq.getDesignerBaseUrl('Designer/ReloadTenant'), data);
            var reloadRuntime = this.piping.dispatcher.doDispatch(lq.getBaseUrl('Runtime/ReloadTenant'), data);

            $.when(reloadDesigner, reloadRuntime)
                .done(function () {
                    continuation();
                });
        }
        else {
            continuation();
        }
    };

    return PlatformCommand;
});
